import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * TbtkSideNavService is used to control the state of the side nav.
 * To open or close menu, add TbtkSideNavService to the component constructor than call `sideNavService.close$.emit(true);` method.
 *
 * Don't forget import it to your project of `@NgModule`'s `providers` section.
 *
 * <sub>app.module.ts</sub>
 *
 * ```typescript
 * @NgModule({
 *   imports: [TbtkSideNavModule],
 *   providers: [TbtkSideNavService]
 * })
 * export class AppModule {}
 * ```
 */
@Injectable({
  providedIn: 'root',
})
export class TbtkSideNavService {
  isClose: boolean = false;
  public close$: Subject<boolean> = new Subject();

  constructor() {
    this.close$.subscribe((status: boolean) => {
      this.isClose = status;
    });
  }
}
